// src/hooks/useConfig.js
import { useContext } from 'react';
import { ConfigContext } from 'contexts/ConfigContext';

// ==============================|| CONFIG - HOOKS ||============================== //

export default function useConfig() {
  const context = useContext(ConfigContext);

  if (!context) throw new Error('useConfig must be used inside ConfigProvider');

  const { state, dispatch } = context;

  // Actions for drawer/sidebar
  const drawerToggle = (open) => dispatch({ type: 'DRAWER_TOGGLE', open });
  const miniDrawerToggle = (mini) => dispatch({ type: 'MINI_DRAWER_TOGGLE', mini });

  return {
    state, // Full state (drawerOpen, etc.)
    dispatch,
    drawerOpen: state.drawerOpen ?? true,
    miniDrawer: state.miniDrawer ?? false,
    drawerToggle,
    miniDrawerToggle,
    // Add more: e.g., theme: state.theme ?? 'light'
  };
}